/**
 * @generated SignedSource<<1491b9f6b9d40d6117dae39b0f4a65fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InitializeTransactionMutation$variables = {};
export type InitializeTransactionMutation$data = {
  readonly unified: {
    readonly linking: {
      readonly initializeLinkingWithLoggedInAccount: {
        readonly errors?: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly id?: string;
        readonly message?: string | null;
        readonly success?: boolean;
        readonly token?: string;
      } | null;
    } | null;
  } | null;
};
export type InitializeTransactionMutation = {
  response: InitializeTransactionMutation$data;
  variables: InitializeTransactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "type": "UnifiedLinkInitiationPayload",
  "abstractKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = {
  "kind": "InlineFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnifiedMutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UnifiedMutationErrorExtension",
          "kind": "LinkedField",
          "name": "extensions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "errorType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusCode",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "UnifiedLinkingStatusPayload",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InitializeTransactionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedMutation",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedLinkingMutation",
            "kind": "LinkedField",
            "name": "linking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "initializeLinkingWithLoggedInAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InitializeTransactionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedMutation",
        "kind": "LinkedField",
        "name": "unified",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UnifiedLinkingMutation",
            "kind": "LinkedField",
            "name": "linking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "initializeLinkingWithLoggedInAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v0/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5879943a798ed8bf43a65dc860bd8202",
    "id": null,
    "metadata": {},
    "name": "InitializeTransactionMutation",
    "operationKind": "mutation",
    "text": "mutation InitializeTransactionMutation {\n  unified {\n    linking {\n      initializeLinkingWithLoggedInAccount {\n        __typename\n        ... on UnifiedLinkInitiationPayload {\n          id\n          token\n        }\n        ... on UnifiedLinkingStatusPayload {\n          message\n          success\n          errors {\n            extensions {\n              errorType\n              statusCode\n            }\n            code\n            message\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "34952189eb0eabf6fa0723e9e170f0bf";

export default node;
